import { StreakCompletionResult, StreakToastMessageMap } from '../user_streak';
import { LeagueWeeklyResult } from '../league_weekly_result';
import { LeagueCompletionCard } from '../league_completion_card';
export class LessonCompletionResult {
    constructor(lessonSessionData, config) {
        var _a, _b;
        Object.defineProperty(this, "badges", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userSeasonAggregateData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lessonStreakCompletionResult", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "workoutStreakCompletionResult", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "leagueWeeklyResult", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "leagueCompletionCard", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.badges = lessonSessionData.badges;
        this.userSeasonAggregateData = lessonSessionData.userSeasonAggregate;
        this.lessonStreakCompletionResult =
            lessonSessionData.streakCompletionResult &&
                new StreakCompletionResult(lessonSessionData.streakCompletionResult, config);
        this.workoutStreakCompletionResult =
            lessonSessionData.workoutGoalAchievementStreakCompletionResult &&
                new StreakCompletionResult(lessonSessionData.workoutGoalAchievementStreakCompletionResult, config);
        const weeklyResult = (_a = lessonSessionData.leagueLessonCompletionResult) === null || _a === void 0 ? void 0 : _a.weeklyResult;
        this.leagueWeeklyResult = weeklyResult ? new LeagueWeeklyResult(weeklyResult, config) : undefined;
        const completionCard = (_b = lessonSessionData.leagueLessonCompletionResult) === null || _b === void 0 ? void 0 : _b.completionCard;
        this.leagueCompletionCard = completionCard ? new LeagueCompletionCard(completionCard, config) : undefined;
    }
    get firstDailyCompletionStreakCompletionResult() {
        return [this.lessonStreakCompletionResult, this.workoutStreakCompletionResult].filter((v) => v === null || v === void 0 ? void 0 : v.isFirstDailyCompletion)[0];
    }
    get streakCompletionResultToast() {
        var _a;
        // lessonStreakCompletionResultはトースト不要
        return StreakToastMessageMap[(_a = this.workoutStreakCompletionResult) === null || _a === void 0 ? void 0 : _a.sourceType];
    }
}
